import {
  Breakpoint,
  BreakpointListener,
  Breakpoints,
  Option,
  RadioGroup,
} from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import React, { ReactElement, useMemo, useState } from 'react';
import { Message, useMessage } from '@messageformat/react';
import CourseTaskHeader from '../CourseTaskHeader';
import { ReactComponent as Image013 } from '../../images/OP_symbolikuvitus_128_013.svg';

type Content = {
  columns: number;
};

const TaskTwo = (): ReactElement => {
  const [value, setValue] = React.useState('');
  const [breakpoint, setBreakpoint] = useState<Breakpoint | null>(null);
  const [showQuestionTwoResult, setShowQuestionTwoResult] = useState(false);
  const questionTwoArray = useMessage('course1.question2.answer_options');

  const content = breakpoint?.content ? (breakpoint.content as Content) : null;

  const breakpoints: Breakpoints = useMemo(() => {
    return [
      { from: 0, to: 767, content: { columns: 1 } },
      {
        from: 768,
        to: Number.MAX_SAFE_INTEGER,
        content: { columns: 2 },
      },
    ];
  }, []);

  return (
    <BreakpointListener breakpoints={breakpoints} onChange={setBreakpoint}>
      <div>
        <CourseTaskHeader questionNumber={2} totalQuestions={2} />
        <h3 className="investoracademy-title-hero">
          <Message id="course1.question2.title" />
        </h3>
        <p className="investoracademy-text-paragraph align-center">
          <Message id="course1.question2.body" />
        </p>
        <RadioGroup
          columns={content?.columns}
          buttons
          onChange={(_ev, val) => {
            setShowQuestionTwoResult(true);
            setValue(val);
          }}
          value={value}
        >
          {Object.keys(questionTwoArray).map((index, val) => {
            return (
              <Option
                key={index}
                value={index}
                labelProps={{
                  style: { padding: '20px', alignItems: 'center', border: 0 },
                  className: 'investoracademy-radio-group-option',
                }}
              >
                <Message id={`${'course1.question2.answer_options'}.${val}`} />
              </Option>
            );
          })}
        </RadioGroup>
      </div>
      <div style={{ display: showQuestionTwoResult ? 'block' : 'none' }}>
        <Image013
          className="investoracademy-small-svg"
          style={{
            marginTop: space.xxl,
          }}
          aria-hidden="true"
        />

        <div
          className="opds-styles-v1-text-title-small-strong"
          style={{ textAlign: 'center', color: '#EE5A00', paddingTop: space.default }}
        >
          <Message id="answer" />
        </div>
        <div
          className="opds-styles-v1-text-title-medium"
          style={{
            textAlign: 'center',
          }}
        >
          {value && <Message id={`${'course1.question2.answer'}.${value}.title`} />}
        </div>
        <div
          className="opds-styles-v1-text-body-medium"
          style={{
            textAlign: 'center',
            paddingBottom: space.default,
            paddingTop: space.small,
          }}
        >
          {value && <Message id={`${'course1.question2.answer'}.${value}.body`} />}
        </div>
      </div>
    </BreakpointListener>
  );
};

export default TaskTwo;
